import {FeatureFlagApiResponse} from 'app_api/projects/feature_flags/types';

export enum ListPageTrackingEvent {
  PageLoaded = `page loaded`,
  ListLoaded = `list loaded`,
  CreateFeatureFlag = `create feature flag`,
}

export enum ViewPageTrackingEvent {
  PageLoaded = `page loaded`,
  DeleteFeatureFlag = `delete feature flag`,
  EditName = `edit name`,
  EditKey = `edit key`,
  EditDescription = `edit description`,
  EditContext = `edit context`,
  EditStatus = `edit status`,
  EditSimpleSettings = `edit simple settings`,
  EditRollouts = `edit rollouts`,
  EditVariants = `edit variant splits`,
}

export enum TrackingEventSource {
  ListPageHeader = `list page header`,
  ListPageMain = `list page main`,
  ViewPageHeader = `view page header`,
  ViewPageMain = `view page main`,
  ViewPageEditSettings = `view page edit settings`,
}

type TrackFeatureFlagParams = {
  event: ListPageTrackingEvent | ViewPageTrackingEvent;
  featureFlag?: FeatureFlagApiResponse;
  props?: Obj;
  source?: TrackingEventSource;
};

export function trackFeatureFlagListPageAction({event, featureFlag, props, source}: TrackFeatureFlagParams) {
  props = props || {};
  mixpanel.track(`[Feature Flag List Page] ${event}`, {
    ...getCommonProps(source),
    ...getFeatureFlagTrackingProperties(featureFlag),
    ...props,
  });
}

export function trackFeatureFlagViewPageAction({event, featureFlag, props, source}: TrackFeatureFlagParams) {
  props = props || {};
  mixpanel.track(`[Feature Flag View Page] ${event}`, {
    ...getCommonProps(source),
    ...getFeatureFlagTrackingProperties(featureFlag),
    ...props,
  });
}

function getCommonProps(source?: TrackingEventSource): Obj {
  return {
    'Request-URL': window.location.href,
    timestamp_ms: Date.now(),
    ...(source ? {source} : {}),
  };
}

function getFeatureFlagTrackingProperties(featureFlag?: FeatureFlagApiResponse): Obj {
  return {
    'flag id': featureFlag?.id,
    'flag creator id': featureFlag?.creator_id,
    'flag name': featureFlag?.name,
    'flag key': featureFlag?.key,
    'flag context': featureFlag?.context,
    'flag status': featureFlag?.status,
    'flag variant count': featureFlag?.ruleset?.variants?.length ?? 0,
    'flat rollout count': featureFlag?.ruleset?.rollout?.length ?? 0,
  };
}
